module.exports = __webpack_public_path__ + "static/media/2-2.f9663c7e.jpg";